import {Component, DestroyRef, ElementRef, inject, Input, OnInit, ViewChild} from '@angular/core';
import {ImageService} from "../../../service/image.service";
import {DomSanitizer} from "@angular/platform-browser";
import {CommonModule} from "@angular/common";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
  selector: 'app-image',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './image.component.html',
  styleUrl: './image.component.scss'
})
export class ImageComponent implements OnInit {

  #destroyRef = inject(DestroyRef);

  @Input()
  src: string | undefined;

  @Input()
  clazz: string | undefined;

  size: string = 'background-size: 50px;';

  imageContent: any;

  @ViewChild('ref') ref: ElementRef | undefined;

  private isEnabled: boolean = true;

  observer: IntersectionObserver | undefined;

  constructor(private imageService: ImageService, private sanitizer: DomSanitizer) {
  }

  ngAfterViewInit() {
    if (this.ref === undefined) {
      return;
    }
    const threshold = 0.2; // how much % of the element is in view
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.ref === undefined || this.observer === undefined) {
              return;
            }
            if (this.isEnabled && this.ref.nativeElement.offsetParent != null) {
              this.load();
              // run your animation code here
              this.observer.disconnect(); // disconnect if you want to stop observing else it will rerun every time its back in view. Just make sure you disconnect in ngOnDestroy instead
            }
          }
        });
      },
      {threshold}
    );
    this.observer.observe(this.ref.nativeElement!);
  }

  ngOnDestroy() {
    if (this.ref === undefined || this.observer === undefined) {
      return;
    }
    this.observer.disconnect();
  }


  ngOnInit() {
    this.imageContent = this.imageService.defaultContent;
    if (this.src === undefined) {
      this.size = 'background-size: 250px;';
      this.imageContent = this.imageService.noImageContent;
      return;
    }
  }

  load() {
    if (this.src === undefined) {
      this.size = 'background-size: 250px;';
      this.imageContent = this.imageService.noImageContent;
      return;
    }
    this.imageService.getImageData(this.src)
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe({
        next: (value: any) => {
          (value as Blob).arrayBuffer().then(value1 => {

            if (value1.byteLength === 0) {
              this.appendNoImage();
            } else {
              this.imageContent = this.imageService.convertData(value1);
              this.size = '';
            }
          })
        },
        error: (error: any) => {
          this.appendNoImage();
        },
        complete: () => {
        }
      }
    );
  }

  getBackgroundImageStyle() {
    let style = "background-image: url(" + this.imageContent + "); " + this.size;
    return this.sanitizer.bypassSecurityTrustStyle(style);
  }

  appendNoImage() {
    this.size = 'background-size: 250px;';
    this.imageContent = this.imageService.noImageContent;
    this.isEnabled = false;
  }

}
